import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface FoodDistributionQRCodeProps {
  /** Override the base URL; defaults to window.location.origin */
  baseUrl?: string;
}

export function FoodDistributionQRCode({ baseUrl }: FoodDistributionQRCodeProps) {
  const origin = baseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  const checkInUrl = `${origin}/food/check-in`;

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(checkInUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="card" style={{ maxWidth: 400 }}>
      <h3 style={{ marginBottom: '0.5rem' }}>Food Distribution QR Code</h3>
      <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
        Print and post this QR code at each distribution site. Clients scan it with their phone camera to check in.
      </p>

      {/* QR code poster */}
      <div
        id="fd-qr-poster"
        style={{
          background: '#5B2C86',
          borderRadius: 16,
          padding: '1.5rem',
          textAlign: 'center',
          marginBottom: '1rem',
        }}
      >
        <p style={{ color: 'white', fontSize: '0.875rem', fontWeight: 600, margin: '0 0 0.75rem 0', fontFamily: 'Montserrat, sans-serif' }}>
          BELAFONTE TACOLCY CENTER
        </p>
        <p style={{ color: '#FAA31B', fontSize: '1.0625rem', fontWeight: 700, margin: '0 0 1rem 0', fontFamily: 'Roboto Slab, serif' }}>
          Food Distribution Check-In
        </p>

        <div
          style={{
            background: 'white',
            borderRadius: 12,
            padding: '1rem',
            display: 'inline-block',
            marginBottom: '1rem',
          }}
        >
          <QRCodeSVG
            value={checkInUrl}
            size={180}
            fgColor="#5B2C86"
            bgColor="white"
            level="M"
          />
        </div>

        <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.8125rem', margin: '0', fontFamily: 'Montserrat, sans-serif' }}>
          Scan with your phone camera
        </p>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', marginTop: '0.25rem', wordBreak: 'break-all', fontFamily: 'Montserrat, sans-serif' }}>
          {checkInUrl}
        </p>
      </div>

      {/* Action buttons */}
      <div style={{ display: 'flex', gap: '0.75rem' }}>
        <button
          onClick={handleCopy}
          className="button-secondary"
          style={{ flex: 1 }}
        >
          {copied ? '✓ Copied!' : 'Copy URL'}
        </button>
        <button
          onClick={handlePrint}
          className="button-primary"
          style={{ flex: 1 }}
        >
          Print Poster
        </button>
      </div>

      <style>{`
        @media print {
          body * { visibility: hidden; }
          #fd-qr-poster, #fd-qr-poster * { visibility: visible; }
          #fd-qr-poster {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 320px;
            border-radius: 16px;
          }
        }
      `}</style>
    </div>
  );
}
